import React from "react";
import { useTranslation } from "react-i18next";
import { Props } from "./types";
import { RoleSelection } from "./roleSelection";
import styles from "./styles.scss";

function VirtualResourceForm({ formData, edit }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.virtualResourceForm}>
      <div className={styles.row}>
        <div className={styles.group}>
          <input
            className={styles.input}
            placeholder={t("virtualResourceForm.namePlaceholder")}
            value={formData.name}
            onChange={({ target }) => edit({ ...formData, name: target.value })}
          />
        </div>
        <div className={styles.group}>
          <RoleSelection
            placeholder={t("virtualResourceForm.rolePlaceholder")}
            selectedRole={formData.role}
            select={(role) => edit({ ...formData, role })}
          />
        </div>
        <div className={styles.group}>
          <input
            className={styles.input}
            placeholder={t("virtualResourceForm.professionPlaceholder")}
            value={formData.profession}
            onChange={({ target }) =>
              edit({ ...formData, profession: target.value })
            }
          />
        </div>
      </div>
    </div>
  );
}

export { VirtualResourceForm };
